module.exports = __webpack_public_path__ + "img/anguilla.c4704350.svg";